// EditProfileTab.jsx
import React, { useEffect, useState } from "react";
import { Formik } from "formik";
import Swal from "sweetalert2";
import { useNavigate, useParams } from "react-router-dom";
import { PHONE_NO_LENGTH, SWAL_SETTINGS } from "../../../../utils/Constants";
import { DT, globalLoader, handleServerValidations } from "../../../../utils/commonfunction";
import * as usersService from "../../services/seller.services";
import * as Yup from "yup";
import { Loader } from "rsuite";
import { useTranslation } from "react-i18next";

const EditProfileTab = () => {
  const navigate = useNavigate();
  const params = useParams();
  const [showdefault, setShowDefault] = useState({});
  const [dataLoaded, setDataLoaded] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    usersService
      .Details({ _id: params.id })
      .then((response) => {
        setShowDefault(response && response.data ? response.data : []);
        setTimeout(() => {
          setDataLoaded(true);
        }, 100);
      })
      .catch((error) => {
        console.log("error=====>", error);
      });
  }, [params.id]);

  const PHONE_REGEX = /^\+?\d{1,4}\s?\d{6,14}$/;
  const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const validationSchema = Yup.object().shape({
    name: Yup.string()
      .required(t("label_name_error"))
      .test("no-spaces", t("label_name_error"), (value) => value && value.trim().length > 0)
      .max(80, t("max_characters_error", { count: 80 })),
    phone_number: Yup.string()
      .required(t("label_phone_error"))
      .matches(PHONE_REGEX, t("label_phone_invalid"))
      .test("no-spaces", t("label_phone_error"), (value) => value && value.trim().length > 0),
    email: Yup.string()
      .required(t("label_email_error"))
      .matches(EMAIL_REGEX, t("label_email_invalid"))
      .max(100, t("max_characters_error", { count: 100 })),
    address: Yup.string()
      .required(t("label_address_error"))
      .test("no-spaces", t("label_address_error"), (value) => value && value.trim().length > 0)
      .max(250, t("max_characters_error", { count: 250 })),
  });

  if (!dataLoaded) {
    return <Loader center size="lg" />;
  }

  return (
    <Formik
      enableReinitialize
      initialValues={{
        name: showdefault?.name || "",
        phone_number: showdefault?.phone_number || "",
        email: showdefault?.email || "",
        address: showdefault?.address || "",
      }}
      validationSchema={validationSchema}
      onSubmit={(values, { setSubmitting }) => {
        globalLoader(true);
        let formData = new FormData();
        formData.append("_id", params.id);
        formData.append("name", values.name);
        formData.append("phone_number", values.phone_number);
        formData.append("email", values.email);
        formData.append("address", values.address);
        
        usersService
          .EditDetails(formData)
          .then((response) => {
            setSubmitting(false);
            globalLoader(false);
            if (response.success) {
              Swal.fire({
                icon: "success",
                text: response.message,
                ...SWAL_SETTINGS,
              });
            } else {
              Swal.fire({
                icon: "error",
                text: handleServerValidations(response),
                ...SWAL_SETTINGS,
              });
            }
          })
          .catch((error) => {
            console.log("error ====> ", error);
            globalLoader(false);
          });
      }}
    >
      {({ values, errors, touched, handleChange, handleBlur, handleSubmit }) => (
        <form onSubmit={handleSubmit}>
          <div className="row row-sm">
            <div className="col-md-12 text-center form-group">
              <label htmlFor="name" className="text-left d-flex">
                {t("label_name")}:<span className="requirestar">*</span>
              </label>
              <input
                name="name"
                id="name"
                type="text"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.name}
                className="form-control"
                placeholder="Enter name"
              />
              <span className="text-danger d-flex text-left">
                {errors.name && touched.name && errors.name}
              </span>
            </div>

            <div className="col-md-12 text-center form-group">
              <label htmlFor="email" className="text-left d-flex">
                {t("label_email")}:<span className="requirestar">*</span>
              </label>
              <input
                name="email"
                type="text"
                id="email"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.email}
                className="form-control"
                placeholder={t("placeholder_email_address")}
              />
              <span className="text-danger d-flex text-left">
                {errors.email && touched.email && t(errors.email)}
              </span>
            </div>

            <div className="col-md-12 text-center form-group">
              <label htmlFor="phone_number" className="text-left d-flex">
                {t("label_contact_no")}:<span className="requirestar">*</span>
              </label>
              <input
                name="phone_number"
                type="tel"
                id="phone_number"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.phone_number}
                className="form-control"
                placeholder={t("web_inquiry_form_placeholder_contact_number")}
              />
              <span className="text-danger d-flex text-left">
                {errors.phone_number && touched.phone_number &&
                  DT(t(errors.phone_number), {
                    PHONE_MIN_LENGTH: PHONE_NO_LENGTH.min,
                    PHONE_MAX_LENGTH: PHONE_NO_LENGTH.max,
                  })}
              </span>
            </div>

            <div className="col-md-12 text-center form-group">
              <label htmlFor="address" className="text-left d-flex">
                {t("label_address")}:<span className="requirestar">*</span>
              </label>
              <input
                name="address"
                id="address"
                type="text"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.address}
                className="form-control"
                placeholder="Enter address"
              />
              <span className="text-danger d-flex text-left">
                {errors.address && touched.address && errors.address}
              </span>
            </div>

            <div className="col-md-12">
              <button className="btn btn-success mr-2" type="submit">
                <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                {t("Update")}
              </button>
              <button
                className="btn ripple btn-secondary"
                type="button"
                onClick={() => navigate(-1)}
              >
                <i className="ace-icon fa fa-times bigger-110 mx-1"></i>
                {t("btn_cancel")}
              </button>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
};

export default EditProfileTab;